var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { black, grey, white } from '../colors/baseColors';
import { sweepColors } from '../colors/sweepColors';
var genericPaletteInput = {
    mode: 'light',
    common: {
        black: black,
        white: white,
    },
    primary: {
        main: sweepColors.blue[500],
        light: sweepColors.blue[300],
        dark: sweepColors.blue[600],
    },
    warning: {
        main: sweepColors.sun[300],
        light: sweepColors.sun[100],
        dark: sweepColors.sun[500],
    },
    error: {
        main: sweepColors.blush[500],
        light: sweepColors.blush[300],
        dark: sweepColors.blush[600],
    },
    info: {
        main: grey[100],
        light: undefined,
        dark: undefined,
    },
    success: {
        main: sweepColors.mint[300],
        light: sweepColors.mint[100],
        dark: sweepColors.mint[500],
    },
    text: {
        primary: black,
        secondary: grey[700],
        disabled: grey[500],
    },
    grey: grey,
};
export var palette = __assign({}, genericPaletteInput);
